/* eslint-disable import/no-unresolved */
import { PATH_DASHBOARD } from 'src/routes/paths';
import Page from 'src/components/Page';
import { Card, Container } from '@material-ui/core';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import useSettings from 'src/hooks/useSettings';
import CollapsableTable from './CollapsableTable';

ExclusionRule.propTypes = {};

export default function ExclusionRule() {
  const { themeStretch } = useSettings();

  return (
    <Page title="Filtering Rule Set | Smart Collect">
      <Container maxWidth={themeStretch ? false : 'lg'} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
        <HeaderBreadcrumbs
          heading="Filtering Rule"
          links={[
            { name: 'Dashboard', href: PATH_DASHBOARD.root },
            { name: 'Filtering Rule', href: PATH_DASHBOARD.general.exclusion_rule }
          ]}
        />
        <Card>
          <CollapsableTable />
        </Card>
      </Container>
    </Page>
  );
}
